import { makeStyles } from "@material-ui/styles";
import { CELL_WIDTHS } from "@utils";

const width = (expanded) => (
  expanded ? CELL_WIDTHS.TITLE_LARGE : CELL_WIDTHS.TITLE_NORMAL
) + CELL_WIDTHS.DRAG_HANDLE

export default makeStyles((theme) => ({
  root: {
    position: "relative",
    width: width(),
    minWidth: width(),
    "& > *": { width: "100%", minWidth: 0 },
    borderRightStyle: "dashed !important",
    borderRightWidth: "1px !important",
    borderRightColor: "transparent",
    boxSizing: "content-box",
    transition: "width 250ms",
    paddingBottom: 16,
    flexShrink: 0,
  },
  expanded: {
    width: width(true),
  },
  collapseExpanded: {
    position: "absolute",
    top: 0,
    right: 4,
    zIndex: 2,
    display: "flex",
    justifyContent: "flex-end",
    pointerEvents: "none",
    "& button": {
      pointerEvents: "auto",
    },
  },
  border: {
    borderRightColor: `${ theme.props.border } !important`,
  }
}));
